export type BeneficialVersionFormSchema = {
  //   registreringspliktigVirksomhet: {
  //     organisasjonsnummer: string;
  //   };
  reelleRettighetshavereidentifikasjon?: string;
  aarsakTilAtVirksomhetIkkeHarReelleRettighetshavere?: {
    erEidEllerKontrollertAvOffentligVirksomhet: boolean;
    erOffentligVirksomhetUtenlandsk?: boolean;
  };
  finnesDetReelleRettighetshavereITilleggTilRolleinnehavereForStiftelse?: boolean;
  reellRettighetshaver?: Array<BeneficialOwnerFormSchema>;
  kanIkkeIdentifisereFlereReelleRettighetshavere?: boolean;
  erVirksomhetRegistrertPaaRegulertMarked?: boolean;
  regulertMarked?: string;
  erReelleRettighetshavereRegistrertIUtenlandskRegister?: boolean;
  utenlandskRegister?: string;

  rolleinnehaver?: Array<{
    foedselsdato: string;
    fulltNavn: string;
    rolle: string;
  }>;
};
export type BeneficialOwnerFormSchema = {
  erRegistrertIFolkeregisteret: boolean;
  folkeregistrertPerson?: {
    foedselsEllerDNummer: string;
  };
  utenlandskPerson?: {
    foedselsdato: string;
    fulltNavn: string;
    bostedsland: string;
    statsborgerskap: string;
  };
  harPosisjonEierskap?: boolean;
  posisjonEierskap?: {
    stoerrelsesintervall: string;
    grunnlag: string;
    mellomliggendeVirksomhet?: Array<{
      erUtenlandskVirksomhet: boolean;
      norskVirksomhet?: {
        organisasjonsnummer: string;
      };
      utenlandskVirksomhet?: {
        registreringsnummerIHjemlandet?: string;
        navn: string;
        adresse: {
          friAdressetekst1: string;
          friAdressetekst2?: string;
          friAdressetekst3?: string;
          landkode: string;
        };
      };
    }>;
  };
  harPosisjonKontrollOverStemmerettigheter?: boolean;
  posisjonKontrollOverStemmerettigheter?: {
    stoerrelsesintervall: string;
    grunnlag: string;
    mellomliggendeVirksomhet?: Array<{
      erUtenlandskVirksomhet: boolean;
      norskVirksomhet?: {
        organisasjonsnummer: string;
      };
      utenlandskVirksomhet?: {
        registreringsnummerIHjemlandet?: string;
        navn: string;
        adresse: {
          friAdressetekst1: string;
          friAdressetekst2?: string;
          friAdressetekst3?: string;
          landkode: string;
        };
      };
    }>;
  };
  harPosisjonRettTilAaUtpekeEllerAvsetteMinstHalvpartenAvStyremedlemmene?: boolean;
  grunnlagForPosisjonenRettTilAaUtpekeEllerAvsetteMinstHalvpartenAvStyremedlemmene?: string;
  harPosisjonKontrollPaaAnnenMaate?: boolean;
  beskrivelseAvPosisjonenKontrollPaaAnnenMaate?: string;
  harPosisjonAvgittGrunnkapital?: boolean;
  harPosisjonRettTilAaUtpekeEtFlertallAvStyremedlemmene?: boolean;
  harPosisjonDestinatar?: boolean;
  harPosisjonSaerligeRettigheter?: boolean;
};
export enum ISONationalCode2Letter {
  AD = 'AD',
  AE = 'AE',
  AF = 'AF',
  AG = 'AG',
  AI = 'AI',
  AL = 'AL',
  AM = 'AM',
  AO = 'AO',
  AQ = 'AQ',
  AR = 'AR',
  AS = 'AS',
  AT = 'AT',
  AU = 'AU',
  AW = 'AW',
  AX = 'AX',
  AZ = 'AZ',
  BA = 'BA',
  BB = 'BB',
  BD = 'BD',
  BE = 'BE',
  BF = 'BF',
  BG = 'BG',
  BH = 'BH',
  BI = 'BI',
  BJ = 'BJ',
  BL = 'BL',
  BM = 'BM',
  BN = 'BN',
  BO = 'BO',
  BQ = 'BQ',
  BR = 'BR',
  BS = 'BS',
  BT = 'BT',
  BV = 'BV',
  BW = 'BW',
  BY = 'BY',
  BZ = 'BZ',
  CA = 'CA',
  CC = 'CC',
  CD = 'CD',
  CF = 'CF',
  CG = 'CG',
  CH = 'CH',
  CI = 'CI',
  CK = 'CK',
  CL = 'CL',
  CM = 'CM',
  CN = 'CN',
  CO = 'CO',
  CR = 'CR',
  CU = 'CU',
  CV = 'CV',
  CW = 'CW',
  CX = 'CX',
  CY = 'CY',
  CZ = 'CZ',
  DE = 'DE',
  DJ = 'DJ',
  DK = 'DK',
  DM = 'DM',
  DO = 'DO',
  DZ = 'DZ',
  EC = 'EC',
  EE = 'EE',
  EG = 'EG',
  EH = 'EH',
  ER = 'ER',
  ES = 'ES',
  ET = 'ET',
  FI = 'FI',
  FJ = 'FJ',
  FK = 'FK',
  FM = 'FM',
  FO = 'FO',
  FR = 'FR',
  GA = 'GA',
  GB = 'GB',
  GD = 'GD',
  GE = 'GE',
  GF = 'GF',
  GG = 'GG',
  GH = 'GH',
  GI = 'GI',
  GL = 'GL',
  GM = 'GM',
  GN = 'GN',
  GP = 'GP',
  GQ = 'GQ',
  GR = 'GR',
  GS = 'GS',
  GT = 'GT',
  GU = 'GU',
  GW = 'GW',
  GY = 'GY',
  HK = 'HK',
  HM = 'HM',
  HN = 'HN',
  HR = 'HR',
  HT = 'HT',
  HU = 'HU',
  ID = 'ID',
  IE = 'IE',
  IL = 'IL',
  IM = 'IM',
  IN = 'IN',
  IO = 'IO',
  IQ = 'IQ',
  IR = 'IR',
  IS = 'IS',
  IT = 'IT',
  JE = 'JE',
  JM = 'JM',
  JO = 'JO',
  JP = 'JP',
  KE = 'KE',
  KG = 'KG',
  KH = 'KH',
  KI = 'KI',
  KM = 'KM',
  KN = 'KN',
  KP = 'KP',
  KR = 'KR',
  KW = 'KW',
  KY = 'KY',
  KZ = 'KZ',
  LA = 'LA',
  LB = 'LB',
  LC = 'LC',
  LI = 'LI',
  LK = 'LK',
  LR = 'LR',
  LS = 'LS',
  LT = 'LT',
  LU = 'LU',
  LV = 'LV',
  LY = 'LY',
  MA = 'MA',
  MC = 'MC',
  MD = 'MD',
  ME = 'ME',
  MF = 'MF',
  MG = 'MG',
  MH = 'MH',
  MK = 'MK',
  ML = 'ML',
  MM = 'MM',
  MN = 'MN',
  MO = 'MO',
  MP = 'MP',
  MQ = 'MQ',
  MR = 'MR',
  MS = 'MS',
  MT = 'MT',
  MU = 'MU',
  MV = 'MV',
  MW = 'MW',
  MX = 'MX',
  MY = 'MY',
  MZ = 'MZ',
  NA = 'NA',
  NC = 'NC',
  NE = 'NE',
  NF = 'NF',
  NG = 'NG',
  NI = 'NI',
  NL = 'NL',
  NO = 'NO',
  NP = 'NP',
  NR = 'NR',
  NU = 'NU',
  NZ = 'NZ',
  OM = 'OM',
  PA = 'PA',
  PE = 'PE',
  PF = 'PF',
  PG = 'PG',
  PH = 'PH',
  PK = 'PK',
  PL = 'PL',
  PM = 'PM',
  PN = 'PN',
  PR = 'PR',
  PS = 'PS',
  PT = 'PT',
  PW = 'PW',
  PY = 'PY',
  QA = 'QA',
  RE = 'RE',
  RO = 'RO',
  RS = 'RS',
  RU = 'RU',
  RW = 'RW',
  SA = 'SA',
  SB = 'SB',
  SC = 'SC',
  SD = 'SD',
  SE = 'SE',
  SG = 'SG',
  SH = 'SH',
  SI = 'SI',
  SJ = 'SJ',
  SK = 'SK',
  SL = 'SL',
  SM = 'SM',
  SN = 'SN',
  SO = 'SO',
  SR = 'SR',
  SS = 'SS',
  ST = 'ST',
  SV = 'SV',
  SX = 'SX',
  SY = 'SY',
  SZ = 'SZ',
  TC = 'TC',
  TD = 'TD',
  TF = 'TF',
  TG = 'TG',
  TH = 'TH',
  TJ = 'TJ',
  TK = 'TK',
  TL = 'TL',
  TM = 'TM',
  TN = 'TN',
  TO = 'TO',
  TR = 'TR',
  TT = 'TT',
  TV = 'TV',
  TW = 'TW',
  TZ = 'TZ',
  UA = 'UA',
  UG = 'UG',
  UM = 'UM',
  US = 'US',
  UY = 'UY',
  UZ = 'UZ',
  VA = 'VA',
  VC = 'VC',
  VE = 'VE',
  VG = 'VG',
  VI = 'VI',
  VN = 'VN',
  VU = 'VU',
  WF = 'WF',
  WS = 'WS',
  YE = 'YE',
  YT = 'YT',
  ZA = 'ZA',
  ZM = 'ZM',
  ZW = 'ZW',
}
export enum ISONationalCode3Letter {
  ABW = 'ABW', // Aruba
  AFG = 'AFG', // Afghanistan
  AGO = 'AGO', // Angola
  AIA = 'AIA', // Anguilla
  ALA = 'ALA', // Åland Islands
  ALB = 'ALB', // Albania
  AND = 'AND', // Andorra
  ARE = 'ARE', // United Arab Emirates
  ARG = 'ARG', // Argentina
  ARM = 'ARM', // Armenia
  ASM = 'ASM', // American Samoa
  ATA = 'ATA', // Antarctica
  ATF = 'ATF', // French Southern Territories
  ATG = 'ATG', // Antigua and Barbuda
  AUS = 'AUS', // Australia
  AUT = 'AUT', // Austria
  AZE = 'AZE', // Azerbaijan
  BDI = 'BDI', // Burundi
  BEL = 'BEL', // Belgium
  BEN = 'BEN', // Benin
  BES = 'BES', // Bonaire, Sint Eustatius and Saba
  BFA = 'BFA', // Burkina Faso
  BGD = 'BGD', // Bangladesh
  BGR = 'BGR', // Bulgaria
  BHR = 'BHR', // Bahrain
  BHS = 'BHS', // Bahamas
  BIH = 'BIH', // Bosnia and Herzegovina
  BLM = 'BLM', // Saint Barthélemy
  BLR = 'BLR', // Belarus
  BLZ = 'BLZ', // Belize
  BMU = 'BMU', // Bermuda
  BOL = 'BOL', // Bolivia, Plurinational State of
  BRA = 'BRA', // Brazil
  BRB = 'BRB', // Barbados
  BRN = 'BRN', // Brunei Darussalam
  BTN = 'BTN', // Bhutan
  BVT = 'BVT', // Bouvet Island
  BWA = 'BWA', // Botswana
  CAF = 'CAF', // Central African Republic
  CAN = 'CAN', // Canada
  CCK = 'CCK', // Cocos (Keeling) Islands
  CHE = 'CHE', // Switzerland
  CHL = 'CHL', // Chile
  CHN = 'CHN', // China
  CIV = 'CIV', // Côte d'Ivoire
  CMR = 'CMR', // Cameroon
  COD = 'COD', // Congo, the Democratic Republic of the
  COG = 'COG', // Congo
  COK = 'COK', // Cook Islands
  COL = 'COL', // Colombia
  COM = 'COM', // Comoros
  CPV = 'CPV', // Cabo Verde
  CRI = 'CRI', // Costa Rica
  CUB = 'CUB', // Cuba
  CUW = 'CUW', // Curaçao
  CXR = 'CXR', // Christmas Island
  CYM = 'CYM', // Cayman Islands
  CYP = 'CYP', // Cyprus
  CZE = 'CZE', // Czechia
  DEU = 'DEU', // Germany
  DJI = 'DJI', // Djibouti
  DMA = 'DMA', // Dominica
  DNK = 'DNK', // Denmark
  DOM = 'DOM', // Dominican Republic
  DZA = 'DZA', // Algeria
  ECU = 'ECU', // Ecuador
  EGY = 'EGY', // Egypt
  ERI = 'ERI', // Eritrea
  ESH = 'ESH', // Western Sahara
  ESP = 'ESP', // Spain
  EST = 'EST', // Estonia
  ETH = 'ETH', // Ethiopia
  FIN = 'FIN', // Finland
  FJI = 'FJI', // Fiji
  FLK = 'FLK', // Falkland Islands (Malvinas)
  FRA = 'FRA', // France
  FRO = 'FRO', // Faroe Islands
  FSM = 'FSM', // Micronesia, Federated States of
  GAB = 'GAB', // Gabon
  GBR = 'GBR', // United Kingdom
  GEO = 'GEO', // Georgia
  GGY = 'GGY', // Guernsey
  GHA = 'GHA', // Ghana
  GIB = 'GIB', // Gibraltar
  GIN = 'GIN', // Guinea
  GLP = 'GLP', // Guadeloupe
  GMB = 'GMB', // Gambia
  GNB = 'GNB', // Guinea-Bissau
  GNQ = 'GNQ', // Equatorial Guinea
  GRC = 'GRC', // Greece
  GRD = 'GRD', // Grenada
  GRL = 'GRL', // Greenland
  GTM = 'GTM', // Guatemala
  GUF = 'GUF', // French Guiana
  GUM = 'GUM', // Guam
  GUY = 'GUY', // Guyana
  HKG = 'HKG', // Hong Kong
  HMD = 'HMD', // Heard Island and McDonald Islands
  HND = 'HND', // Honduras
  HRV = 'HRV', // Croatia
  HTI = 'HTI', // Haiti
  HUN = 'HUN', // Hungary
  IDN = 'IDN', // Indonesia
  IMN = 'IMN', // Isle of Man
  IND = 'IND', // India
  IOT = 'IOT', // British Indian Ocean Territory
  IRL = 'IRL', // Ireland
  IRN = 'IRN', // Iran, Islamic Republic of
  IRQ = 'IRQ', // Iraq
  ISL = 'ISL', // Iceland
  ISR = 'ISR', // Israel
  ITA = 'ITA', // Italy
  JAM = 'JAM', // Jamaica
  JEY = 'JEY', // Jersey
  JOR = 'JOR', // Jordan
  JPN = 'JPN', // Japan
  KAZ = 'KAZ', // Kazakhstan
  KEN = 'KEN', // Kenya
  KGZ = 'KGZ', // Kyrgyzstan
  KHM = 'KHM', // Cambodia
  KIR = 'KIR', // Kiribati
  KNA = 'KNA', // Saint Kitts and Nevis
  KOR = 'KOR', // Korea, Republic of
  KWT = 'KWT', // Kuwait
  LAO = 'LAO', // Lao People's Democratic Republic
  LBN = 'LBN', // Lebanon
  LBR = 'LBR', // Liberia
  LBY = 'LBY', // Libya
  LCA = 'LCA', // Saint Lucia
  LIE = 'LIE', // Liechtenstein
  LKA = 'LKA', // Sri Lanka
  LSO = 'LSO', // Lesotho
  LTU = 'LTU', // Lithuania
  LUX = 'LUX', // Luxembourg
  LVA = 'LVA', // Latvia
  MAC = 'MAC', // Macao
  MAF = 'MAF', // Saint Martin (French part)
  MAR = 'MAR', // Morocco
  MCO = 'MCO', // Monaco
  MDA = 'MDA', // Moldova, Republic of
  MDG = 'MDG', // Madagascar
  MDV = 'MDV', // Maldives
  MEX = 'MEX', // Mexico
  MHL = 'MHL', // Marshall Islands
  MKD = 'MKD', // Macedonia, the former Yugoslav Republic of
  MLI = 'MLI', // Mali
  MLT = 'MLT', // Malta
  MMR = 'MMR', // Myanmar
  MNE = 'MNE', // Montenegro
  MNG = 'MNG', // Mongolia
  MNP = 'MNP', // Northern Mariana Islands
  MOZ = 'MOZ', // Mozambique
  MRT = 'MRT', // Mauritania
  MSR = 'MSR', // Montserrat
  MTQ = 'MTQ', // Martinique
  MUS = 'MUS', // Mauritius
  MWI = 'MWI', // Malawi
  MYS = 'MYS', // Malaysia
  MYT = 'MYT', // Mayotte
  NAM = 'NAM', // Namibia
  NCL = 'NCL', // New Caledonia
  NER = 'NER', // Niger
  NFK = 'NFK', // Norfolk Island
  NGA = 'NGA', // Nigeria
  NIC = 'NIC', // Nicaragua
  NIU = 'NIU', // Niue
  NLD = 'NLD', // Netherlands
  NOR = 'NOR', // Norway
  NPL = 'NPL', // Nepal
  NRU = 'NRU', // Nauru
  NZL = 'NZL', // New Zealand
  OMN = 'OMN', // Oman
  PAK = 'PAK', // Pakistan
  PAN = 'PAN', // Panama
  PCN = 'PCN', // Pitcairn
  PER = 'PER', // Peru
  PHL = 'PHL', // Philippines
  PLW = 'PLW', // Palau
  PNG = 'PNG', // Papua New Guinea
  POL = 'POL', // Poland
  PRI = 'PRI', // Puerto Rico
  PRK = 'PRK', // Korea, Democratic People's Republic of
  PRT = 'PRT', // Portugal
  PRY = 'PRY', // Paraguay
  PSE = 'PSE', // Palestine, State of
  PYF = 'PYF', // French Polynesia
  QAT = 'QAT', // Qatar
  REU = 'REU', // Réunion
  ROU = 'ROU', // Romania
  RUS = 'RUS', // Russian Federation
  RWA = 'RWA', // Rwanda
  SAU = 'SAU', // Saudi Arabia
  SDN = 'SDN', // Sudan
  SEN = 'SEN', // Senegal
  SGP = 'SGP', // Singapore
  SGS = 'SGS', // South Georgia and the South Sandwich Islands
  SHN = 'SHN', // Saint Helena, Ascension and Tristan da Cunha
  SJM = 'SJM', // Svalbard and Jan Mayen
  SLB = 'SLB', // Solomon Islands
  SLE = 'SLE', // Sierra Leone
  SLV = 'SLV', // El Salvador
  SMR = 'SMR', // San Marino
  SOM = 'SOM', // Somalia
  SPM = 'SPM', // Saint Pierre and Miquelon
  SRB = 'SRB', // Serbia
  SSD = 'SSD', // South Sudan
  STP = 'STP', // Sao Tome and Principe
  SUR = 'SUR', // Suriname
  SVK = 'SVK', // Slovakia
  SVN = 'SVN', // Slovenia
  SWE = 'SWE', // Sweden
  SWZ = 'SWZ', // Swaziland
  SXM = 'SXM', // Sint Maarten (Dutch part)
  SYC = 'SYC', // Seychelles
  SYR = 'SYR', // Syrian Arab Republic
  TCA = 'TCA', // Turks and Caicos Islands
  TCD = 'TCD', // Chad
  TGO = 'TGO', // Togo
  THA = 'THA', // Thailand
  TJK = 'TJK', // Tajikistan
  TKL = 'TKL', // Tokelau
  TKM = 'TKM', // Turkmenistan
  TLS = 'TLS', // Timor-Leste
  TON = 'TON', // Tonga
  TTO = 'TTO', // Trinidad and Tobago
  TUN = 'TUN', // Tunisia
  TUR = 'TUR', // Turkey
  TUV = 'TUV', // Tuvalu
  TWN = 'TWN', // Taiwan, Province of China
  TZA = 'TZA', // Tanzania, United Republic of
  UGA = 'UGA', // Uganda
  UKR = 'UKR', // Ukraine
  UMI = 'UMI', // United States Minor Outlying Islands
  URY = 'URY', // Uruguay
  USA = 'USA', // United States of America
  UZB = 'UZB', // Uzbekistan
  VAT = 'VAT', // Holy See
  VCT = 'VCT', // Saint Vincent and the Grenadines
  VEN = 'VEN', // Venezuela, Bolivarian Republic of
  VGB = 'VGB', // Virgin Islands, British
  VIR = 'VIR', // Virgin Islands, U.S.
  VNM = 'VNM', // Viet Nam
  VUT = 'VUT', // Vanuatu
  WLF = 'WLF', // Wallis and Futuna
  WSM = 'WSM', // Samoa
  YEM = 'YEM', // Yemen
  ZAF = 'ZAF', // South Africa
  ZMB = 'ZMB', // Zambia
  ZWE = 'ZWE', // Zimbabwe
}
